var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAccordion48Filled = function SvgIconAccordion48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.599 9.3a5.3 5.3 0 0 0-5.3 5.3v18.8a5.3 5.3 0 0 0 5.3 5.3h18.8a5.3 5.3 0 0 0 5.3-5.3V14.6a5.3 5.3 0 0 0-5.3-5.3h-18.8Zm5.32 10.43a1.7 1.7 0 0 0-1.41 2.649l4.08 6.06a1.7 1.7 0 0 0 2.82 0l4.08-6.06a1.7 1.7 0 0 0-1.41-2.65h-8.16Z",
    fill: "current"
  })));
};
export default SvgIconAccordion48Filled;